export const TRUSTED_BUSINESSES = [
  { name: "Reel Gardening", color: "#2f9e44" },
  { name: "Moko Africa", color: "#e08a00" },
  { name: "The Brick", color: "#d4522f" },
  { name: "Toy Kingdom", color: "#2b6fd6" },
  { name: "Grass Farms", color: "#2f9e4a" },
  { name: "Indus Water", color: "#1a8fc0" },
  { name: "NWU", color: "#9b5cb8" },
  { name: "Customline", color: "#c48a12" },
  { name: "Crumbs and Cream", color: "#d45a78" },
  { name: "Core Catering", color: "#d46b28" },
  { name: "G4S", color: "#0f9e94" },
  { name: "Zcreations", color: "#d63d72" },
  { name: "SSDS", color: "#3d72d6" },
  { name: "DB Enterprise", color: "#c48a12" },
  { name: "Sara Rope", color: "#b07838" },
  { name: "GoDaily", color: "#0f9e8a" },
];
